
<template>
	<p>Page not found</p>
</template>

<script>
export default {

}

</script>


// WEBPACK FOOTER //
// 404.vue?229d5332